import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portabilidadmenu',
  standalone: true,
  imports: [],
  templateUrl: './portabilidadmenu.component.html',
  styleUrl: './portabilidadmenu.component.scss'
})
export class PortabilidadmenuComponent {

  constructor(private readonly router: Router) {}

  seleccionarOpcion(opcion: string) {
    if (opcion === 'certificado') {
      console.log("Navegando a Certificado...");
      this.router.navigate(['/solicitudcertificadoliquidaciondeuda']); 
    } 
    
    else if (opcion === 'portabilidad') {
      console.log("Navegando a Portabilidad...");
      this.router.navigate(['/solicitudportabilidadfinanciera']); 
    }
  }

}
